import {Prompt, PicLink, EventBanner, Quicklink, EventResources, ScrollReset} from './obj.js'

import workshop from './img/workshops/workshop-1.webp'
import will from './img/workshops/IMG_1118.webp'
import oldposter from './img/workshops/workshop3 (1).webp'
import newposter from './img/workshops/2025-s1-w3.webp'
import work1 from './img/workshops/work1.webp'
import work2 from './img/workshops/work2.webp'

import location from './icons/mdi_location.svg'
import dmoj from './icons/dmoj_white.png'
import vjudge from './icons/vjudge.svg'

export default function Workshops(){
    return (<>
        <main className = "eventpage">
            <ScrollReset/>
            <EventBanner>Weekly<br/>Workshops</EventBanner>
            <section className= "twocol">
                <Prompt text = "Workshops >>">In weekly workshops, students get a chance to both learn and apply topics relevant to competitive programming. 
                    <br></br>
                    <br></br>
                    Our members will first deliver a brief overview of the topic, highlighting theory, implementation and extensions. Then, students get the chance to showcase their knowledge in a short competition.
                    <br></br>
                    <br></br>
                    Workshop topics, timing and locations can be seen on our Discord.
                </Prompt>
                <div className = 'twobytwo'>
                    <PicLink src = {will}></PicLink>
                    <PicLink src = {workshop}></PicLink>
                    <PicLink src = {oldposter}></PicLink>
                    <PicLink src = {newposter}></PicLink>
                </div>
            </section>
            <section className= "twocol">

                <div className = 'twobytwo'>
                    
                    <br/>
                    <PicLink src = {work2}></PicLink>
                    <PicLink src = {work1}></PicLink>
                    <br/>
                    
                </div>
                <EventResources>
                    <Quicklink src = {location} path = '/map'>Workshop location</Quicklink>
                    <Quicklink src = {dmoj} path = '/dmoj'>DMOJ</Quicklink>
                    <Quicklink src = {vjudge} path = '/vjudge'>Vjudge</Quicklink> 
                </EventResources>
            </section>

        </main>
    </>)
}